import { render, staticRenderFns } from "./border-comp2.vue?vue&type=template&id=f47fd406"
import script from "./border-comp2.vue?vue&type=script&lang=js"
export * from "./border-comp2.vue?vue&type=script&lang=js"
import style0 from "./border-comp2.vue?vue&type=style&index=0&id=f47fd406&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports